// Get the current host from the browser's location
const getCurrentHost = (): string => {
  if (typeof window !== 'undefined') {
    return window.location.hostname;
  }
  return 'localhost';
};

// Get the API URL based on environment
export const getApiUrl = (): string => {
  // 1. Check for explicit environment variable (production)
  const envApiUrl = process.env.REACT_APP_API_URL;
  if (envApiUrl) {
    return envApiUrl;
  }

  // 2. Fall back to auto-detection (development)
  const host = getCurrentHost();
  const port = '8000'; // Backend port
  return `http://${host}:${port}`;
};

export const API_BASE_URL = getApiUrl();

// Helper function to get API URL with path
export const getApiEndpoint = (path: string): string => {
  return `${API_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};

// Environment info
export const isProduction = process.env.NODE_ENV === 'production';

// Debug info (only in development)
if (process.env.NODE_ENV === 'development') {
  console.log('API Configuration:', {
    currentHost: getCurrentHost(),
    apiBaseUrl: API_BASE_URL,
    fromEnv: !!process.env.REACT_APP_API_URL
  });
}